<template>
  <v-container>
    <v-card elevation="1">
      <v-card-title>
        <v-btn
          icon
          small
          class="mr-2"
          color="secondary"
          @click="$router.push('results')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>My Schools</h1>
        <v-spacer></v-spacer>
        <v-btn @click="print" color="primary" class="mr-2 no-print">
          <v-icon>mdi-printer</v-icon>
          Print
        </v-btn>
        <v-btn @click="exportCSV" color="secondary no-print">
          <v-icon>mdi-download</v-icon>
          MSC Application Tracker Export
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="this.$store.getters.selectedSchools"
          :headers="table.headers"
          :sort-desc.sync="table.sortDesc"
          sort-by="percentage"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.level="{ item }">
            {{ formatTier(item.level) }}
          </template>
          <template v-slot:item.mddo="{ item }">
            {{ item.mddo ? item.mddo.toUpperCase() : '' }}
          </template>
          <template v-slot:item.percentage="{ item }">
            <v-chip
              class="ma-2"
              :color="getAcceptanceColor(item.percentage)"
              text-color="white"
              v-if="item.percentage"
            >
              {{ item.percentage }}%
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import schoolService from '../services/SchoolService';
import { json2excel } from 'js2excel';

const tierOrder = [
  'International',
  'Osteopathic',
  'Low/Mid Tier',
  'Mid/High Tier',
  'High Tier',
  'Top Tier',
];

export default {
  name: 'MySchools',
  data: () => ({
    table: {
      sortDesc: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'MD/DO',
          value: 'mddo',
          sortable: true,
        },
        {
          text: 'State',
          value: 'state',
          sortable: true,
        },
        {
          text: 'Avg MCAT',
          value: 'fy_mcat',
          sortable: true,
        },
        {
          text: 'Avg GPA',
          value: 'fy_total_gpa',
          sortable: true,
        },
        {
          text: 'Avg Science GPA',
          value: 'fy_science_gpa',
          sortable: true,
        },
        {
          text: 'Tier',
          value: 'level',
          sortable: true,
          sort: (a, b) => {
            if (tierOrder.indexOf(a) > tierOrder.indexOf(b)) return 1;
            if (tierOrder.indexOf(a) < tierOrder.indexOf(b)) return -1;
            return 0;
          },
        },
        {
          text: 'MSC Competitiveness Score',
          value: 'msc',
          sortable: true,
        },
        {
          text: 'Public/Private',
          value: 'type',
          sortable: true,
        },
        {
          text: 'Out of State Percentage',
          value: 'percentage',
          sortable: true,
        },
      ],
    },
    level: 0,
    finalScore: 0,
    singleSchoolID: null,
    showDialog: false,
  }),
  created() {
    this.$store.dispatch('loadFromSession');
    this.level = this.$store.getters.level;
    this.finalScore = this.$store.getters.finalScore;
  },
  methods: {
    formatTier(value) {
      if (value !== undefined) {
        return value.replace('Tier', '');
      }
    },
    getAcceptanceColor(percentage) {
      return schoolService.getAcceptanceColor(percentage);
    },
    getStateColor(schoolState) {
      return schoolService.getStateColor(
        schoolState,
        this.$store.getters.user.state
      );
    },

    print() {
      window.print();
    },

    exportCSV() {
      const data = this.$store.getters.selectedSchools.map((school) => ({
        Name: school.name,
        "MD/DO": school.mddo ? school.mddo.toUpperCase() : '',
        State: school.state,
        "Avg MCAT": school.fy_mcat,
        "Avg GPA": school.fy_total_gpa,
        "Avg Science GPA": school.fy_science_gpa,
        Tier: this.formatTier(school.level),
        "MSC Competitiveness Score": school.msc,
        "Public/Private": school.type,
        "Out of State Percentage": `${school.percentage}%`,
      }));

      json2excel({
        data,
        name: 'MSC_Application_Tracker', 
      });
    }

  },
};
</script>
<style lang="scss" scoped>
.no-print {
  @media print {
    display: none;
  }
}
</style>
